// components/profesionales/Calificaciones/Calificaciones.js
import React from 'react'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Card from 'react-bootstrap/Card'
import ProgressBar from 'react-bootstrap/ProgressBar'
import Alert from 'react-bootstrap/Alert'
import './Calificaciones.css'

function Calificaciones({ datos }) {
	// Si no hay datos de calificaciones
	if (!datos || !datos.promedio) {
		return (
			<Alert variant="info">
				Este profesional aún no tiene calificaciones
			</Alert>
		)
	}

	// Calcular el porcentaje de cada nivel de estrellas
	const calcularPorcentaje = (cantidad) => {
		if (!datos.total || datos.total === 0) return 0
		return Math.round((cantidad / datos.total) * 100)
	}

	return (
		<Container fluid className="calificaciones-container">
			<Row>
				<Col xs={12} md={4} className="mb-4">
					<Card className="calificacion-resumen">
						<Card.Body className="text-center">
							<div className="puntuacion-grande">{datos.promedio.toFixed(1)}</div>
							<div className="estrellas-grandes">
								{[...Array(5)].map((_, i) => (
									<i
										key={i}
										className={`fa fa-star ${i < Math.round(datos.promedio) ? 'activa' : ''}`}
									></i>
								))}
							</div>
							<div className="total-reviews">
								Basado en {datos.total} {datos.total === 1 ? 'calificación' : 'calificaciones'}
							</div>
						</Card.Body>
					</Card>
				</Col>

				<Col xs={12} md={8} className="mb-4">
					<Card>
						<Card.Body>
							<h5 className="mb-3">Distribución de calificaciones</h5>

							{/* 5 estrellas */}
							<div className="d-flex align-items-center mb-2">
								<div className="stars-label">5 estrellas</div>
								<ProgressBar
									className="flex-grow-1 mx-2"
									variant="success"
									now={calcularPorcentaje(datos.distribucion?.[5] || 0)}
								/>
								<div className="percentage-label">
									{calcularPorcentaje(datos.distribucion?.[5] || 0)}%
								</div>
							</div>

							{/* 4 estrellas */}
							<div className="d-flex align-items-center mb-2">
								<div className="stars-label">4 estrellas</div>
								<ProgressBar
									className="flex-grow-1 mx-2"
									variant="info"
									now={calcularPorcentaje(datos.distribucion?.[4] || 0)}
								/>
								<div className="percentage-label">
									{calcularPorcentaje(datos.distribucion?.[4] || 0)}%
								</div>
							</div>

							{/* 3 estrellas */}
							<div className="d-flex align-items-center mb-2">
								<div className="stars-label">3 estrellas</div>
								<ProgressBar
									className="flex-grow-1 mx-2"
									variant="primary"
									now={calcularPorcentaje(datos.distribucion?.[3] || 0)}
								/>
								<div className="percentage-label">
									{calcularPorcentaje(datos.distribucion?.[3] || 0)}%
								</div>
							</div>

							{/* 2 estrellas */}
							<div className="d-flex align-items-center mb-2">
								<div className="stars-label">2 estrellas</div>
								<ProgressBar
									className="flex-grow-1 mx-2"
									variant="warning"
									now={calcularPorcentaje(datos.distribucion?.[2] || 0)}
								/>
								<div className="percentage-label">
									{calcularPorcentaje(datos.distribucion?.[2] || 0)}%
								</div>
							</div>

							{/* 1 estrellas */}
							<div className="d-flex align-items-center">
								<div className="stars-label">1 estrella</div>
								<ProgressBar
									className="flex-grow-1 mx-2"
									variant="danger"
									now={calcularPorcentaje(datos.distribucion?.[1] || 0)}
								/>
								<div className="percentage-label">
									{calcularPorcentaje(datos.distribucion?.[1] || 0)}%
								</div>
							</div>
						</Card.Body>
					</Card>
				</Col>
			</Row>

			{/* Comentarios de usuarios */}
			{datos.comentarios && datos.comentarios.length > 0 && (
				<Row>
					<Col xs={12}>
						<Card>
							<Card.Header>
								<h5 className="mb-0">Comentarios de usuarios</h5>
							</Card.Header>
							<Card.Body>
								{datos.comentarios.map((comentario, index) => (
									<div key={index} className="comentario-item">
										<div className="comentario-header">
											<div className="comentario-usuario">
												<strong>{comentario.usuario || 'Usuario'}</strong>
											</div>
											<div className="comentario-estrellas">
												{[...Array(5)].map((_, i) => (
													<i
														key={i}
														className={`fa fa-star ${i < comentario.puntuacion ? 'activa' : ''}`}
													></i>
												))}
											</div>
											<div className="comentario-fecha">
												{comentario.fecha || 'Sin fecha'}
											</div>
										</div>
										<div className="comentario-texto">
											{comentario.texto || 'Sin comentario'}
										</div>
										{index < datos.comentarios.length - 1 && <hr />}
									</div>
								))}
							</Card.Body>
						</Card>
					</Col>
				</Row>
			)}
		</Container>
	)
}

export default Calificaciones